module.exports = __webpack_public_path__ + "img/pdf-icon.c919d52c.svg";